import { useEffect, useState } from "react";
import "./ServidorShop.css";

const Items = () => {
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    fetch("/api/tienda-servidor/items")
      .then((res) => res.json())
      .then((data) => {
        setItems(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        console.error("Error cargando items:", error);
        setItems([]);
      })
      .finally(() => {
        setCargando(false);
      });
  }, []);

  if (cargando) {
    return <p className="shop-loading">Cargando items...</p>;
  }

  return (
    <main className="shop-page">
      <section className="shop-hero">
        <span>📦 TIENDA DEL SERVIDOR</span>
        <h1>Items disponibles</h1>
        <p>Consulta los precios oficiales de los items dentro del servidor.</p>
      </section>

      <section className="shop-table-card">
        <div className="shop-table-header">
          <h2>Lista de Items</h2>
          <p>{items.length} items encontrados</p>
        </div>

        <table className="shop-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Item</th>
              <th>Precio</th>
              <th>Recompra</th>
            </tr>
          </thead>

          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="4">No hay items disponibles.</td>
              </tr>
            ) : (
              items.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.itemName}</td>
                  <td>${Number(item.cost).toFixed(2)}</td>
                  <td>${Number(item.buyBack).toFixed(2)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </section>
    </main>
  );
};

export default Items;